import { Button, Divider, Form, Input } from 'antd';
import { POLICY_NAME } from '../../POLICY';
import { useTranslation } from 'react-i18next';
import Editor from '../../../../components/Shared/forms/EditorPrivacy';
import { useEffect } from 'react';
import {
    ArrowLeftOutlined,
    ArrowRightOutlined,
    InfoCircleOutlined,
} from '@ant-design/icons';
import BtnSave from './BtnSave';
import Sticky from 'react-sticky-el';
import { checkValidForm } from './Step1';
import { EXAMLE, INIT } from './init';
import TextBox from '../../Shared/TextBox';
import { useState } from 'react';

const Step8 = (props) => {
    const { t } = useTranslation(['translation', POLICY_NAME.CCTV_POLICY]);
    const [haveError, setHaveError] = useState(false);

    const onNextStep = () => {
        if (props.passStep) {
            props.nextStep();
            props?.form
                .validateFields()
                .then(() => {
                    props.setStep8(true);
                    setHaveError(false);
                })
                .catch(() => {
                    props.setStep8(false);
                    setHaveError(true);
                });
        } else {
            setHaveError(true);
        }
    };

    useEffect(() => {
        if (props.passStep) {
            setHaveError(false);
        }
    }, [props.passStep]);

    const onPreviousStep = () => {
        props.previousStep();
    };

    useEffect(() => {
        if (props?.previewData?.cctvPolicyChange) {
            onValuesChange(null, props?.previewData?.cctvPolicyChange);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.previewData]);

    const onValuesChange = (change, allValues) => {
        const fields = [
            'cctvChangeTitleTh',
            'cctvChangeTitleEn',
            'cctvDataControllerTitleTh',
            'cctvDataControllerTitleEn',
            'cctvDataControllerContentTh',
            'cctvDataProtectionTitleTh',
            'cctvDataProtectionTitleEn',
            'cctvDataProtectionContentTh',
        ];
        const check = checkValidForm(fields, allValues);
        props.setStep8(check);
    };

    const cctvCompanyNameTh =
        props.cctvPolicy?.cctvCompanyNameTh || '[company_name]';
    const cctvCompanyNameEn =
        props.cctvPolicy?.cctvCompanyNameEn || '[company_name]';

    return (
        <div className="px-4 block_">
            <div className="text-purple-PHX font-semibold text-2xl">
                {t('Policy change and contact channels', {
                    ns: POLICY_NAME.CCTV_POLICY,
                })}
            </div>
            <div className="text-gray-500 text-tiny">{t('policy.desEtc')}</div>
            <Divider />
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                onValuesChange={onValuesChange}
                name="cctvPolicyChange"
                layout="vertical"
                form={props?.form}
                initialValues={INIT.cctvPolicyChange}
            >
                <div>
                    <div className="text-purple-PHX font-semibold text-xl">
                        {t('Changes to the cctvs Policy', {
                            ns: POLICY_NAME.CCTV_POLICY,
                        })}
                    </div>
                    <Form.Item
                        label={
                            <span className="text-sm font-semibold">
                                {t(
                                    'Title of the topic displayed in the document',
                                    {
                                        ns: POLICY_NAME.CCTV_POLICY,
                                        lang: 'TH',
                                    }
                                )}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        name="cctvChangeTitleTh"
                    >
                        <Input size="large" maxLength={200} showCount />
                    </Form.Item>
                    <div className="text-sm font-semibold">
                        {t('Example Data')}
                    </div>
                    <TextBox
                        code={EXAMLE.cctvChangeContentTh.replace(
                            /\{\{c\}\}/g,
                            cctvCompanyNameTh
                        )}
                    />
                    <Form.Item
                        className="mt-4"
                        name="cctvChangeContentTh"
                        label={
                            <span className="text-sm font-semibold">
                                {t('Content', { lang: 'TH' })}
                            </span>
                        }
                    >
                        <Editor
                            size="large"
                            rows={4}
                            placeholder={t('Content', { lang: 'TH' })}
                        />
                    </Form.Item>

                    <Form.Item
                        label={
                            <span className="text-sm font-semibold">
                                {t(
                                    'Title of the topic displayed in the document',
                                    {
                                        ns: POLICY_NAME.CCTV_POLICY,
                                        lang: 'EN',
                                    }
                                )}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        name="cctvChangeTitleEn"
                    >
                        <Input size="large" maxLength={200} showCount />
                    </Form.Item>
                    <div className="text-sm font-semibold">
                        {t('Example Data')}
                    </div>
                    <TextBox
                        code={EXAMLE.cctvChangeContentEn.replace(
                            /\{\{c\}\}/g,
                            cctvCompanyNameEn
                        )}
                    />
                    <Form.Item
                        className="mt-4"
                        name="cctvChangeContentEn"
                        label={
                            <span className="text-sm font-semibold">
                                {t('Content', { lang: 'EN' })}
                            </span>
                        }
                    >
                        <Editor
                            size="large"
                            rows={4}
                            placeholder={t('Content', { lang: 'EN' })}
                        />
                    </Form.Item>
                </div>
                <Divider />
                <div>
                    <div className="text-purple-PHX font-semibold text-xl">
                        ผู้ควบคุมข้อมูลส่วนบุคคล (Data Controller)
                    </div>
                    <Form.Item
                        label={
                            <span className="text-sm font-semibold">
                                {t(
                                    'Title of the topic displayed in the document',
                                    {
                                        ns: POLICY_NAME.CCTV_POLICY,
                                        lang: 'TH',
                                    }
                                )}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        name="cctvDataControllerTitleTh"
                    >
                        <Input size="large" maxLength={200} showCount />
                    </Form.Item>

                    <Form.Item
                        className="mt-4"
                        name="cctvDataControllerContentTh"
                        label={
                            <span className="text-sm font-semibold">
                                {t('Content', { lang: 'TH' })}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                    >
                        <Editor
                            size="large"
                            rows={4}
                            placeholder={t('Content', { lang: 'TH' })}
                        />
                    </Form.Item>

                    <Form.Item
                        label={
                            <span className="text-sm font-semibold">
                                {t(
                                    'Title of the topic displayed in the document',
                                    {
                                        ns: POLICY_NAME.CCTV_POLICY,
                                        lang: 'EN',
                                    }
                                )}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        name="cctvDataControllerTitleEn"
                    >
                        <Input size="large" maxLength={200} showCount />
                    </Form.Item>
                    <Form.Item
                        className="mt-4"
                        name="cctvDataControllerContentEn"
                        label={
                            <span className="text-sm font-semibold">
                                {t('Content', { lang: 'EN' })}
                            </span>
                        }
                    >
                        <Editor
                            size="large"
                            rows={4}
                            placeholder={t('Content', { lang: 'EN' })}
                        />
                    </Form.Item>
                </div>

                <Divider />
                <div>
                    <div className="text-purple-PHX font-semibold text-xl">
                        เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล (Data Protection
                        Officer: DPO)
                    </div>
                    <Form.Item
                        label={
                            <span className="text-sm font-semibold">
                                {t(
                                    'Title of the topic displayed in the document',
                                    {
                                        ns: POLICY_NAME.CCTV_POLICY,
                                        lang: 'TH',
                                    }
                                )}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        name="cctvDataProtectionTitleTh"
                    >
                        <Input size="large" maxLength={200} showCount />
                    </Form.Item>

                    <Form.Item
                        className="mt-4"
                        name="cctvDataProtectionContentTh"
                        label={
                            <span className="text-sm font-semibold">
                                {t('Content', { lang: 'TH' })}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                    >
                        <Editor
                            size="large"
                            rows={4}
                            placeholder={t('Content', { lang: 'TH' })}
                        />
                    </Form.Item>

                    <Form.Item
                        label={
                            <span className="text-sm font-semibold">
                                {t(
                                    'Title of the topic displayed in the document',
                                    {
                                        ns: POLICY_NAME.CCTV_POLICY,
                                        lang: 'EN',
                                    }
                                )}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        name="cctvDataProtectionTitleEn"
                    >
                        <Input size="large" maxLength={200} showCount />
                    </Form.Item>
                    <Form.Item
                        className="mt-4"
                        name="cctvDataProtectionContentEn"
                        label={
                            <span className="text-sm font-semibold">
                                {t('Content', { lang: 'EN' })}
                            </span>
                        }
                    >
                        <Editor
                            size="large"
                            rows={4}
                            placeholder={t('Content', { lang: 'EN' })}
                        />
                    </Form.Item>
                    <Form.Item hidden name="cctvChangeIsDisplay"></Form.Item>
                    <Form.Item
                        hidden
                        name="cctvDataControllerIsDisplay"
                    ></Form.Item>
                    <Form.Item
                        hidden
                        name="cctvDataProtectionIsDisplay"
                    ></Form.Item>
                    <Form.Item hidden name="cctvPolicyChangeId"></Form.Item>
                </div>

                <Sticky
                    mode="bottom"
                    boundaryElement=".block_"
                    stickyClassName="bg-white p-4 shadow h-16 rounded-lg z-50"
                >
                    <div className="flex items-center">
                        <Button
                            type="default"
                            size="large"
                            onClick={onPreviousStep}
                        >
                            <ArrowLeftOutlined /> {t('policy.PreviousStep')}
                        </Button>
                        <Button
                            type="primary"
                            size="large"
                            className="ml-4"
                            onClick={onNextStep}
                        >
                            {t('Preview before publishing')}{' '}
                            <ArrowRightOutlined />
                        </Button>
                        <BtnSave
                            loading={props.loadingSaveDraft}
                            saveDraft={props.saveDraft}
                        />
                    </div>
                    {haveError && (
                        <div className="text-red-500 space-x-2 mt-2">
                            <InfoCircleOutlined />
                            <span>
                                {t(
                                    'Unable to preview before release Please complete the required information on each tab'
                                )}
                            </span>
                        </div>
                    )}
                </Sticky>
            </Form>
        </div>
    );
};

export default Step8;
